import React from "react";
import { Link } from "react-router-dom";

const SimpleWhiteButton = (props) => {
  const { text, to, email, onclick, disabled } = props;
  return (
    <Link to={to} state={{ email: email ? email : "" }}>
      <button
        onClick={onclick}
        disabled={disabled}
        className="bg-white w-[170px] p-3 flex items-center text-center justify-center rounded-lg"
      >
        <p className="text-[#0D121C] text-xs font-semibold uppercase">{text}</p>
      </button>
    </Link>
  );
};

export default SimpleWhiteButton;
